<template>
  <v-container fluid>
    <div class="toolbar d-flex flex-row justify-space-between align-center elevation-3 mb-3">
      <span>
        Exportation Countries
      </span>
      <div
        class="d-flex flex-row align-center"
        style="gap: 0.625rem;">
        <v-btn
          v-if="isEdit"
          color="error"
          outlined
          rounded
          small
          :loading="loading"
          @click="onReset()">
          {{ $t('button.Reset') }}
        </v-btn>
        <v-btn
          color="success"
          rounded
          small
          :loading="loading"
          :disabled="!isEdit"
          @click="updateAllItems()">
          {{ $t('button.Save') }}
        </v-btn>
        <v-btn
          color="secondary"
          rounded
          small
          :loading="loading"
          @click="onAddItem()">
          {{ $t('button.Add') }}
        </v-btn>
      </div>
    </div>

    <v-form
      ref="form"
      @submit.prevent="updateAllItems()">
      <v-row class="px-8">
        <v-col
          cols="12"
          class="card-container elevation-3">
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="query.limit"
            :loading="loading"
            hide-default-footer>
            <template #[`item.displayCountryPriceInTag`]="{ index }">
              <div class="d-flex flex-row justify-center align-center">
                <v-switch
                  v-model="items[index].displayCountryPriceInTag"
                  inset
                  dense
                >
                </v-switch>
              </div>
            </template>
            <template #[`item.country`]="{ index }">
              <v-autocomplete
                v-model="items[index].country"
                :rules="selectRules"
                placeholder="ประเทศ"
                color="secondary"
                prepend-inner-icon="mdi-flag-variant-outline"
                :items="shippingCountries"
                item-text="country"
                item-value="code"
                dense
                hide-details />
            </template>
            <template #[`item.currency`]="{ index }">
              <v-autocomplete
                v-model="items[index].currency"
                :rules="selectRules"
                placeholder="สกุลเงิน"
                color="secondary"
                prepend-inner-icon="mdi-cash"
                :items="currencies"
                item-text="text"
                item-value="value"
                dense
                hide-details />
            </template>
            <template #[`item.value`]="{ index }">
              <v-text-field
                v-model.number="items[index].value"
                type="number"
                :rules="numberRules"
                :readonly="loading"
                suffix="฿"
                placeholder="THB"
                color="secondary"
                dense
                hide-details />
            </template>
            <template #[`item.vat`]="{ index }">
              <v-text-field
                v-model.number="items[index].vat"
                type="number"
                :rules="numberRules"
                :readonly="loading"
                suffix="%"
                placeholder="VAT Percent"
                color="secondary"
                dense
                hide-details />
            </template>
            <template #[`item.discount`]="{ index }">
              <v-text-field
                v-model.number="items[index].discount"
                type="number"
                :rules="numberRules"
                :readonly="loading"
                suffix="%"
                placeholder="Discount Percent"
                color="secondary"
                dense
                hide-details />
            </template>
            <template #[`item.round`]="{ index }">
              <v-text-field
                v-model.number="items[index].round"
                type="number"
                :rules="numberRules"
                :readonly="loading"
                append-icon="mdi-numeric"
                placeholder="Round"
                color="secondary"
                dense
                hide-details />
            </template>
            <template #[`item.action`]="{ item, index }">
              <div class="d-flex flex-row justify-center align-center">
                <!-- <v-btn
                  color="secondary"
                  small
                  icon
                  :disabled="!item.country || (!item.value && item.value !== 0)"
                  @click="confirmUpdateItem(item)">
                  <v-icon small>
                    mdi-check-all
                  </v-icon>
                </v-btn> -->
                <v-btn
                  color="error"
                  small
                  icon
                  @click="removeItem(index)">
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import ExportCurrencyRatesProvider from '@/resources/ExportCurrencyRatesProvider'
import { getRole } from '@/assets/js/Authentication'
import ShippingCountries from '@/assets/json/ShippingCountries.json'

const ExportCurrencyRatesService = new ExportCurrencyRatesProvider()

export default {
  data () {
    return {
      headers: [
        {
          text: 'แสดงในป้ายราคา',
          value: 'displayCountryPriceInTag',
          sortable: false,
          align: 'center'
        },
        {
          text: 'ประเทศ',
          value: 'country',
          sortable: false,
          align: 'center'
        },
        {
          text: 'สกุลเงิน',
          value: 'currency',
          sortable: false,
          align: 'center'
        },
        {
          text: 'ค่าเงิน (THB)',
          value: 'value',
          sortable: false,
          align: 'center'
        },
        {
          text: 'VAT (%)',
          value: 'vat',
          sortable: false,
          align: 'center'
        },
        {
          text: 'ส่วนลด (%)',
          value: 'discount',
          sortable: false,
          align: 'center'
        },
        {
          text: 'ปัดเศษ',
          value: 'round',
          sortable: false,
          align: 'center'
        },
        {
          text: 'ตัวเลือก',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      memoItems: [],
      items: [],
      sortByOptions: [
        {
          text: 'ประเทศ',
          value: 'country'
        },
        {
          text: 'วันที่สร้าง',
          value: 'createdAt'
        },
        {
          text: 'วันที่แก้ไข',
          value: 'updatedAt'
        }
      ],
      sortOrderOptions: [
        {
          text: 'A-Z',
          value: 'asc'
        },
        {
          text: 'Z-A',
          value: 'desc'
        }
      ],
      query: {
        sortBy: 'createdAt',
        sortOrder: 'asc'
      },
      loading: false,
      selectRules: [
        (v) => !!v || 'This field is required.'
      ],
      numberRules: [
        (v) => /^[+-]?([0-9]*[.])?[0-9]+$/.test(v) || 'This field is invalid.',
        (v) => v >= 0 || 'This field must be positive number.'
      ]
    }
  },
  computed: {
    isDeveloper () {
      return getRole() === 'developer'
    },
    isEdit () {
      return JSON.stringify(this.items) !== JSON.stringify(this.memoItems)
    },
    shippingCountries () {
      return ShippingCountries.map((country) => ({
        ...country,
        disabled: this.items.some((item) => item.country === country.code)
      }))
    },
    currencies () {
      const tmpCurrencies = [
        {
          text: 'THB',
          value: 'THB'
        },
        {
          text: 'USD',
          value: 'USD'
        },
        {
          text: 'EUR',
          value: 'EUR'
        },
        {
          text: 'GBP',
          value: 'GBP'
        },
        {
          text: 'JPY',
          value: 'JPY'
        },
        {
          text: 'CNY',
          value: 'CNY'
        },
        {
          text: 'KRW',
          value: 'KRW'
        },
        {
          text: 'VND',
          value: 'VND'
        },
        {
          text: 'PHP',
          value: 'PHP'
        },
        {
          text: 'IDR',
          value: 'IDR'
        },
        {
          text: 'MYR',
          value: 'MYR'
        },
        {
          text: 'SGD',
          value: 'SGD'
        },
        {
          text: 'BND',
          value: 'BND'
        },
        {
          text: 'KHR',
          value: 'KHR'
        },
        {
          text: 'LAK',
          value: 'LAK'
        },
        {
          text: 'MMK',
          value: 'MMK'
        }
      ]

      return tmpCurrencies.map((currency) => ({
        ...currency,
        disabled: this.items.some((item) => item.currency === currency.value)
      }))
    }
  },
  watch: {
    'query.sortBy': {
      handler () {
        this.getItems(true)
      },
      deep: true
    },
    'query.sortOrder': {
      handler () {
        this.getItems(true)
      },
      deep: true
    }
  },
  mounted () {
    this.getItems(true)
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setModal: 'Components/setModal'
    }),
    getShippingCountry (code) {
      return ShippingCountries.find((country) => country.code === code)?.country || code
    },
    onAddItem () {
      this.items.push({
        country: '',
        currency: '',
        value: 0,
        vat: 0,
        discount: 0,
        round: 1,
        displayCountryPriceInTag: false
      })
    },
    async getItems (isClear = false) {
      try {
        this.loading = true

        const { data } = await ExportCurrencyRatesService.getItems({
          sortBy: this.query.sortBy,
          sortOrder: this.query.sortOrder
        })

        if (isClear) {
          this.memoItems = []
          this.items = []
        }

        this.memoItems = JSON.parse(JSON.stringify(data))
        this.items = data
      } catch (error) {
        console.error('getItems', error)
        this.setSnackbar({
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    confirmUpdateItem (item) {
      this.setModal({
        value: true,
        title: 'Update Item',
        message: `Do you want to update ${this.getShippingCountry(item.country)}?`,
        confirmText: 'Update',
        confirmType: 'success',
        cancelType: '',
        cancelText: 'Cancel',
        onConfirm: () => this.updateItem(item.id)
      })
    },
    confirmUpdateAllItems () {
      this.setModal({
        value: true,
        title: 'Update Item',
        message: 'Do you want to update all items?',
        confirmText: 'Update',
        confirmType: 'success',
        cancelType: '',
        cancelText: 'Cancel',
        onConfirm: () => this.updateAllItems()
      })
    },
    removeItem (index) {
      this.items.splice(index, 1)
    },
    onReset () {
      this.items = JSON.parse(JSON.stringify(this.memoItems))
    },
    async updateAllItems () {
      try {
        this.loading = true

        const isValid = await this.$refs.form.validate()

        if (!isValid) {
          return
        }

        const toBeInActive = this.memoItems.filter((item) => !this.items.some((i) => i.id === item.id))
        const mappedItems = []

        for (const item of this.items) {
          mappedItems.push({
            ...item,
            active: true
          })
        }

        for (const item of toBeInActive) {
          mappedItems.push({
            ...item,
            active: false
          })
        }

        await ExportCurrencyRatesService.updateAllItems({
          items: mappedItems
        })

        this.getItems(true)
      } catch (error) {
        console.error('updateAllItems', error)
        this.setSnackbar({
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async updateItem (id) {
      try {
        this.loading = true

        await ExportCurrencyRatesService.updateItem(id, this.items.find((item) => item.id === id))

        this.getItems(true)
      } catch (error) {
        console.error('updateItem', error)
        this.setSnackbar({
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  position: sticky;
  top: 70px;
  left: 0;
  width: 100%;
  z-index: 5;
  background-color: #fff;
  padding: 1.25rem 1.875rem;
  border-radius: 0.625rem;
}
.toolbar span {
  font-weight: bold;
  font-size: 1.25rem;
}
.card-container {
  padding: 1.25rem 1.875rem;
  background-color: #fff;
  border-radius: 0.625rem;
  margin-top: 1.25rem;
}
.card-title {
  font-weight: bold;
  font-size: 1.35rem;
}
</style>
